import React, {useEffect} from 'react';
import {Menu, Item, Separator, Submenu, MenuProvider, useContextMenu} from 'react-contexify';
import 'react-contexify/dist/ReactContexify.css';
import ImMenu from "./menu";


const RightClick = (imProps) => {
    const {show} = useContextMenu({
        id: imProps.menuId,
    });

    function handleContextMenu(event) {
        event.preventDefault();
        show(event, {
            props: {
                key: 'value'
            }
        })
    }

    const handleItemClick = ({event, props}) => console.log(event, props);

    return (
        <>
            {/*右键的html*/}
            {
                React.Children.map(imProps.children, child => React.cloneElement(child, {onContextMenu: handleContextMenu}))
            }

            {/*右键菜单内容*/}
            <Menu id={imProps.menuId} className={'im-rightclick-menu'}>
                {/*{*/}
                {/*    imProps.item.map((data)=>{*/}
                {/*        return <Item onClick={data.type='download'?()=>{}:data.onClick}>{data.name}</Item>*/}
                {/*    })*/}
                {/*}*/}
                <ImMenu>
                    {imProps.item}
                </ImMenu>
            </Menu>

            {/*<Menu id={MENU_ID} className={'im-rightclick-menu'}>*/}
            {/*<Item onClick={handleItemClick}>Item 1</Item>*/}
            {/*<Item onClick={handleItemClick}>Item 2</Item>*/}
            {/*<Item onClick={handleItemClick}>Item 3</Item>*/}
            {/*<Separator/>*/}
            {/*<Item disabled>Disabled</Item>*/}
            {/*<Separator/>*/}
            {/*<Submenu label="Foobar">*/}
            {/*    <Item onClick={handleItemClick}>Sub Item 1</Item>*/}
            {/*    <Item onClick={handleItemClick}>Sub Item 2</Item>*/}
            {/*</Submenu>*/}
            {/*</Menu>*/}
        </>
    );
}

export default RightClick